$(function () {
  // 客户端状态初始化
  // 初始化命名空间
  window.litime = {
    debounce,
    throttle,
    showLoading,
    hideLoading,
    openChatApp,
    disableScroll,
    enableScroll,
    i18n: {}, // 添加 i18n 对象
    initWhenVisible,
  };
});


// scroll-animation[Start]
// 动画模块
const AnimationModule = (() => {
  // 注册 GSAP 插件
  gsap.registerPlugin(ScrollTrigger);

  // 获取每个类对应的动画配置
  // 获取每个类对应的动画配置
  function getAnimationOptions(element) {
    let options = {
      opacity: 0,
      x: 0,
      y: 0,
      duration: 1,
      delay: 0.2,
      scrollTriggerOptions: {
        trigger: element,
        start: 'top 80%',
        toggleActions: 'play none none none',
      },
    };

    // 根据元素的类名设置不同的动画效果
    if (element.classList.contains('to-left')) {
      options.x = -100; // 向左滑动
    } else if (element.classList.contains('to-top')) {
      options.y = 30; // 从下到上滑动
    } else if (element.classList.contains('to-edge')) {
      options.x = -150; // 向左滑动更多
    } else if (element.classList.contains('slide-to-left')) {
      options.x = -200; // 向左滑动更大距离
    } else if (element.classList.contains('to-opacity')) {
      options.opacity = 0; // 透明度动画
    } else if (element.classList.contains('to-top1')) {
      options.y = -50; // 向上移动（不同的距离）
    } else if (element.classList.contains('text-top')) {
      options.y = -150; // 向上移动较大距离
    } else if (element.classList.contains('text-top-btn')) {
      options.y = -200; // 按钮向上移动
    } else if (element.classList.contains('slide-to-left-white')) {
      options.x = -300; // 白色滑动动画
    } else if (element.classList.contains('line-top')) {
      options.y = -50; // 线条向上移动
    }

    return options;
  }

  // 元素进入视口动画
  function animateOnScroll(selector) {
    gsap.utils.toArray(selector).forEach((element) => {
      const animationOptions = getAnimationOptions(element);

      gsap.from(element, {
        opacity: animationOptions.opacity,
        x: animationOptions.x,
        y: animationOptions.y,
        duration: 0.5,
        delay: animationOptions.delay,
        scrollTrigger: {
          trigger: element,
          start: 'top 100%',
          toggleActions: 'play none none none',
          markers: false,
        },
      });
    });
  }

  // 数字增长动画
  function animateNumber(selector, endValue, duration = 2) {
    const element = document.querySelector(selector);

    // 格式化数字的函数
    function formatNumber(number) {
      if (number >= 1000000) {
        return (number / 1000000).toFixed(1) + 'M'; // 大于等于 1M 时，转换为 M
      } else if (number >= 1000) {
        return (number / 1000).toFixed(1) + 'K'; // 大于等于 1K 时，转换为 K
      } else {
        return number; // 小于 1000 时，保持原数字
      }
    }

    // 如果结束值大于等于1000，直接设置格式化后的值
    const formattedEndValue = formatNumber(endValue);

    // 动画开始前，立即显示格式化后的数字（避免滚动动画）
    element.innerText = formattedEndValue;

    // 如果要滚动动画，使用 GSAP 来逐步更新数字
    gsap.to(element, {
      duration: duration,
      innerText: endValue,
      snap: { innerText: 1 },
      ease: 'power1.out',
      onUpdate: function () {
        // 在每次更新时格式化数字并显示
        element.innerText = formatNumber(Math.floor(this.targets()[0].innerText));
      },
    });
  }

  // 为文字添加包装和延迟效果
  function addTextAnimation(selector, delay = 0.1) {
    gsap.utils.toArray(selector).forEach((element, index) => {
      gsap.from(element, {
        opacity: 0,
        y: 20,
        duration: 1,
        delay: index * delay,
        scrollTrigger: {
          trigger: element,
          start: 'top 80%',
        },
      });
    });
  }

  // 滚动节流（可选）
  function throttle(func, limit) {
    let inThrottle;
    return function () {
      const args = arguments;
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => (inThrottle = false), limit);
      }
    };
  }

  function getAnimationOptions(element) {
    let options = {
      opacity: 0,
      x: 0,
      y: 0,
      duration: 0.3,
      delay: 0.2,
      scrollTriggerOptions: {
        trigger: element,
        start: 'top 80%',
        toggleActions: 'play none none none',
      },
    };

    // 根据元素的类名设置不同的动画效果
    if (element.classList.contains('to-left')) {
      options.x = -100; // 向左滑动
    } else if (element.classList.contains('to-top')) {
      options.y = 30; // 从下到上滑动
    } else if (element.classList.contains('to-edge')) {
      options.x = -150; // 向左滑动更多
    } else if (element.classList.contains('slide-to-left')) {
      options.x = -200; // 向左滑动更大距离
    } else if (element.classList.contains('to-opacity')) {
      options.opacity = 0; // 透明度动画
    } else if (element.classList.contains('to-top1')) {
      options.y = -50; // 向上移动（不同的距离）
    } else if (element.classList.contains('text-top')) {
      options.y = -150; // 向上移动较大距离
    } else if (element.classList.contains('text-top-btn')) {
      options.y = -200; // 按钮向上移动
    } else if (element.classList.contains('slide-to-left-white')) {
      options.x = -300; // 白色滑动动画
    } else if (element.classList.contains('line-top')) {
      options.y = -50; // 线条向上移动
    }

    return options;
  }

  // 初始化动画
  function init() {
    // 示例调用封装的动画方法
    animateOnScroll(
      '.to-left, .to-edge, .to-top, .slide-to-left, .to-opacity, .to-top1, .text-top, .text-top-btn, .slide-to-left-white, .line-top'
    );
    addTextAnimation('.text-top span');
  }

  // 返回模块中的方法以便调用
  return {
    init,
    animateOnScroll,
    animateNumber,
    addTextAnimation,
    throttle,
  };
})();

// 使用示例
$(document).ready(() => {
  AnimationModule.init(); // 初始化所有动画
});

/**
 * 视图滚动动画
 * 使用方法：
 * 1. 多元素
 * <div lt-scrollspy="target: .scroll-inview-item; y: 30;">
 *   <div class="scroll-inview-item">Item 1</div>
 *   <div class="scroll-inview-item">Item 2</div>
 *   <div class="scroll-inview-item">Item 3</div>
 * </div>
 *  参数：
 * target: 目标元素
 * x: 水平偏移，默认为0
 * y: 垂直偏移，默认为0
 * duration: 动画持续时间，默认为0.6
 * delay: 每个元素的延迟时间，默认为0.15
 * ease: 缓动函数，默认为''
 *
 * 2. 单独元素
 * <div lt-scroll-inview="y: 30;">
 *   <div>Item 1</div>
 *   <div>Item 2</div>
 *   <div>Item 3</div>
 *   <div>Item 4</div>
 * </div>
 * 参数：
 * x: 水平偏移，默认为0
 * y: 垂直偏移，默认为0
 * duration: 动画持续时间，默认为0.6
 * delay: 每个元素的延迟时间，默认为0.15
 * ease: 缓动函数，默认为''
 */
class ScrollAnimations {
  constructor() {
    this.init();
  }

  init() {
    gsap.registerPlugin(ScrollTrigger);

    // 处理多元素动画
    document.querySelectorAll('[lt-scrollspy]').forEach((container) => {
      const config = this.parseConfig(container.getAttribute('lt-scrollspy'));
      const targets = container.querySelectorAll(config.target);

      const originOverflow = container.style.overflow;
      container.style.overflow = 'initial';

      gsap.set(targets, {
        opacity: 0,
        x: config.x,
        y: config.y,
      });
      ScrollTrigger.batch(targets, {
        start: 'top 90%',
        // 分批处理
        batchMax: targets.length,
        // 批次间隔
        interval: 0.1,
        onEnter: (elements) => {
          gsap.to(elements, {
            opacity: config.opacity,
            x: 0,
            y: 0,
            duration: config.duration,
            ease: config.ease,
            stagger: {
              each: config.delay,
              from: 'start',
            },
            overwrite: true,
            onComplete: () => {
              const lastTarget = targets[targets.length - 1];
              const lastElement = elements[elements.length - 1];
              if (lastTarget === lastElement) {
                container.style.overflow = originOverflow;
              }
            },
          });
        },
      });
    });

    // 处理单独元素动画
    gsap.utils.toArray('[lt-scroll-inview]').forEach((element) => {
      const config = this.parseConfig(element.getAttribute('lt-scroll-inview'));
      gsap.set(element, {
        opacity: 0,
        x: config.x,
        y: config.y,
      });
      gsap.to(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 90%',
          toggleActions: 'play none none none',
        },
        opacity: config.opacity,
        x: 0,
        y: 0,
        duration: config.duration,
        ease: config.ease,
        overwrite: true,
      });
    });
  }

  // 解析配置
  parseConfig(attr) {
    // 默认配置
    const config = {
      target: '.scroll-inview-item',
      opacity: 1, // 目标透明度
      x: 0, // 初始 X 偏移
      y: 0, // 初始 Y 偏移
      duration: 0.6, // 动画持续时间
      delay: 0.15, // 每个元素的延迟时间
      ease: '', // 缓动函数
    };
    if (!attr) return config;
    // 解析属性字符串
    attr.split(';').forEach((item) => {
      const [key, value] = item.split(':').map((str) => str.trim());
      if (key && value) {
        // 转换数值类型的参数
        if (['x', 'y', 'duration', 'delay'].includes(key)) {
          config[key] = parseFloat(value);
        } else {
          config[key] = value;
        }
      }
    });
    return config;
  }

  // 清理方法
  destroy() {
    ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
  }
}
// 初始化视图滚动动画
$(document).ready(() => {
  new ScrollAnimations();
});
// scroll-animation[End]

function initWhenVisible(options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    },
    { rootMargin: `0px 0px ${threshold}px 0px` }
  );

  observer.observe(options.element);
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}
(function () {
  const escapeSelector = (selector) => {
    return selector.replace(/([!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, '\\$1');
  };

  $(document.body).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
    const $link = $(this);
    let originalHref = $link.attr('href') || '';

    // 统一处理空href
    if (!originalHref || originalHref === '#') {
      $link.attr('href', 'javascript:;');
      return;
    }

    // 提取并验证hash
    const hashMatch = originalHref.match(/#(.+)/);
    if (!hashMatch) {
      $link.attr('href', 'javascript:;');
      return;
    }

    const targetId = escapeSelector(hashMatch[1]);
    const $target = $(`#${targetId}`);

    // 目标不存在处理
    if (!$target.length) {
      console.warn(`Anchor target #${targetId} not found`);
      $link.attr('href', 'javascript:;');
      return;
    }

    // 滚动逻辑（保持原有优化）
    const targetElement = document.getElementById(targetId);
    const headerHeight = document.querySelector('header')?.offsetHeight || 0;
    const scrollPosition = targetElement.offsetTop - headerHeight;

    try {
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth',
        });
      } else {
        $('html, body').stop().animate({ scrollTop: scrollPosition }, { duration: 200, easing: 'swing' });
      }
    } catch (error) {
      console.error('Scroll error:', error);
    }

    // 焦点管理
    if (document.activeElement !== targetElement) {
      targetElement.setAttribute('tabindex', '-1');
      targetElement.focus({ preventScroll: true });
    }
  });
})();

/**
 * 为元素添加唯一事件监听器
 * @param {HTMLElement} element - 需要绑定事件的元素
 * @param {string} eventType - 事件类型，如 'click'
 * @param {Function} handler - 事件处理函数
 * 使用方式
 * customEventListener(button, 'click', () => {
      
    });
 */
function customEventListener(element, eventType, handler) {
  if (element && !element._eventListeners) {
    //
    element._eventListeners = {};
  }

  if (element && !element._eventListeners[eventType]) {
    element.addEventListener(eventType, handler);
    element._eventListeners[eventType] = handler; // 记录已绑定事件
  }
}

/**
 * 格式化价格
 * @param {number} cents - 需要格式化的价格
 * @param {string} format - 格式化字符串
 * @returns {string} 格式化后的价格
 * 使用方式
 * Shopify.formatMoney(100, '{{ shop.money_format }}');
 */
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// 防抖函数
function debounce(fn, delay = 300) {
  let timer = null;

  return function (...args) {
    if (timer) clearTimeout(timer);

    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

// 节流函数
function throttle(fn, delay = 300) {
  let timer = null;

  return function (...args) {
    if (timer) return;

    timer = setTimeout(() => {
      fn.apply(this, args);
      timer = null;
    }, delay);
  };
}

function showLoading() {
  $('.global-loading_wrapper').addClass('flex').removeClass('hidden');
  window.litime.disableScroll();
}

function hideLoading() {
  $('.global-loading_wrapper').removeClass('flex').addClass('hidden');
  window.litime.enableScroll();
}
async function getCartDrawer(triggerElement = null) {
  // 获取购物车抽屉元素
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    // document.querySelector('.empty-cart-drawer').classList.remove('hidden');
    // document.querySelector('.cart-drawer-content').classList.add('hidden');
    // document.querySelector('.bottom-drawer-container').classList.add('hidden');
    // 打开购物车抽屉，如果有触发元素就传入
    cartDrawer.open(triggerElement);
    // 更新购物车内容
    await cartDrawer.getCartContent();
  }
}

// 添加全局遮罩层管理
window.overlayManager = {
  $overlay: null,
  currentType: null, // 添加当前遮罩层类型标记

  show(type = 'drawer') {
    // 先移除所有可能存在的遮罩层
    $('.overlay-mask, .drawer-overlay-mask').remove();

    // 设置当前类型
    this.currentType = type;
    const scrollbarWidth = getScrollbarWidth();

    window.litime.disableScroll();

    // 根据类型创建不同的遮罩层
    if (type === 'header') {
      this.$overlay = $('<div></div>')
        .addClass('overlay-mask')
        .css({
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 99,
          marginLeft: `-${scrollbarWidth}px`,
        });
    } else if (type === 'header-search') {
      this.$overlay = $('<div></div>')
        .addClass('search-overlay-mask')
        .css({
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 99,
          marginLeft: `-${scrollbarWidth}px`,
        });
    } else {
      this.$overlay = $('<div></div>')
        .addClass('drawer-overlay-mask')
        .css({
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 800,
          marginLeft: `-${scrollbarWidth}px`,
        });
    }

    $('#MainContent').append(this.$overlay);
    return this.$overlay;
  },

  hide(type = 'drawer') {
    // 只有当要隐藏的类型与当前显示的类型相同时才执行隐藏
    if (type === this.currentType) {
      if (this.$overlay) {
        this.$overlay.remove();
        this.$overlay = null;
      }
      // 只移除对应类型的遮罩层
      if (type === 'header') {
        $('.overlay-mask').remove();
      } else if (type === 'header-search') {
        $('.search-overlay-mask').remove();
      } else {
        $('.drawer-overlay-mask').remove();
      }
      window.litime.enableScroll();

      this.currentType = null;
    }
  },

  get() {
    return this.$overlay;
  },
};

function openChatApp() {
  const chatApp = document.querySelector('#ShopifyChat');
  if (chatApp) {
    const shadowRoot = chatApp.shadowRoot;
    const button = shadowRoot.querySelector('button');
    button.click();
  }
}

// 添加获取滚动条宽度的函数
function getScrollbarWidth() {
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  document.body.appendChild(outer);

  const inner = document.createElement('div');
  outer.appendChild(inner);

  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  outer.parentNode.removeChild(outer);

  return scrollbarWidth;
}
// 添加禁用滚动条的方法
function disableScroll() {
  const scrollbarWidth = getScrollbarWidth();
  document.body.style.overflow = 'hidden';
  document.body.style.paddingRight = `${scrollbarWidth}px`;

  // 处理固定定位的元素
  document.querySelectorAll('.fixed-header, .fixed-element').forEach((el) => {
    el.style.paddingRight = `${scrollbarWidth}px`;
  });
}
// 添加恢复滚动条的方法
function enableScroll() {
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';

  // 处理固定定位的元素
  document.querySelectorAll('.fixed-header, .fixed-element').forEach((el) => {
    el.style.paddingRight = '';
  });
}
// 正则校验

const ltUtils = {
  rule: {
    email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/, //邮箱规则：任何值
    password_confirmation: /^.{6,}$/,
    password: /^.{6,}$/,
    any_value: /^.+$/, //规则: 任何值
  },
};
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// 解析和更新购物车相关组件
async function updateCartComponents(cartContent) {
  if (!cartContent?.sections) return;

  const parser = new DOMParser();

  // 更新购物车抽屉
  if (cartContent.sections['cart-drawer']) {
    const doc = parser.parseFromString(cartContent.sections['cart-drawer'], 'text/html');
    const cartDrawer = document.querySelector('cart-drawer');
    const cartDrawerContent = doc.querySelector('cart-drawer');
    if (cartDrawer && cartDrawerContent) {
      cartDrawer.innerHTML = cartDrawerContent.innerHTML;
      cartDrawer.bindRemoveButtons(); // 先重新绑定删除按钮事件
      cartDrawer.init(); // 然后初始化其他功能
    }
  }

  // 更新购物车图标
  if (cartContent.sections['cart-icon-bubble']) {
    const iconDoc = parser.parseFromString(cartContent.sections['cart-icon-bubble'], 'text/html');
    const iconBubble = document.querySelector('cart-icon-bubble');
    if (iconBubble) {
      iconBubble.innerHTML = iconDoc.querySelector('cart-icon-bubble').innerHTML;
    }
  }
}
